import { Injectable } from '@angular/core';
import { HttpHelper } from './http.service';
import { AppConfig } from '../model/config';
import { DriverReport } from '../model/report/driverReport';

@Injectable()
export class ReportService {
  constructor(
    private readonly configuration: AppConfig,
    private readonly http: HttpHelper) {

  }

  public async getInvoicesReportDb(from: string, to: string): Promise<any> {

    let url: string = this.configuration.backendUrl + "/api/report/invoicesn/" + from + "/" + to;

    return await this.http.get(url, () => { },
      () => { }).toPromise<any>();
  }

  public async getflightReport(startDate: string, endDate: string, flight: string): Promise<any> {
    let url: string = `${this.configuration.backendUrl}/api/report/flight?startDate=${startDate}&endDate=${endDate}`;

    if (flight) {
      url += `&flight=${flight}`
    }

    return await this.http.get(url, () => { },
      () => { }).toPromise<any>();
  }

  public async getDriverReports(date: string, name: string): Promise<DriverReport[]> {
    const url = this.configuration.backendUrl + "/api/report/driver/" + date + "/" + name;

    return await this.http.get(url, () => { },
      () => { }).toPromise<any>();
  }

  public async gettransferReport(date: string, transfer: string): Promise<any> {
    const url = this.configuration.backendUrl + "/api/report/transfer/" + transfer + "?date=" + date;

    return await this.http.get(url, () => { },
      () => { }).toPromise<any>();
  }

  public async gettransferSummaryReport(from: string, to: string, gate: string): Promise<any> {

    let url: string = this.configuration.backendUrl + "/api/report/transferSummary/" + gate + "/" + from + "/" + to;

    return await this.http.get(url, () => { },
      () => { }).toPromise<any>();
  }

  public async getKpiReport(date: string, getPerHour: boolean = false): Promise<any> {
    let url: string = `${this.configuration.backendUrl}/api/report/kpi/${date}?getPerHour=${getPerHour}`;

    return await this.http.get(url, () => { },
      () => { }).toPromise<any>();
  }

  public async getCheckInReport(from: Date, to: Date): Promise<any> {
    let url: string = `${this.configuration.backendUrl}/api/Report/checkIn?from=${from.toISOString()}&to=${to.toISOString()}`;

    return await this.http.get(url, () => { },
      () => { }).toPromise<any>();
  }

}
